import React, { useEffect } from 'react';
import { FeaturedSharePriceProps } from './config';
import { YourIR } from 'yourir-react';
import { sanitizeHTML } from 'utils/SecurityHelper';
import { appID, shareInfoItems } from './constants';

const FeaturedSharePrice = ({
  linkurl = '',
  heading = '',
  sharelabel = '',
  datetext = '',
  design = '',
  topBottomPadding = '',
  sidePadding = '',
  backgroundcolor = '',
  transparent = '',
}: FeaturedSharePriceProps) => {
  useEffect(() => {
    if (window.grunticon) {
      window.grunticon.embedIcons(
        window.grunticon.getIcons(window.grunticon.getCSS(window.grunticon.href))
      );
    }
  }, []);
  return (
    <div className={`module module--investor-tile ${topBottomPadding} ${design}`}>
      <div className={`module__content ${sidePadding}`}>
        <div>
          <a
            href={linkurl !== '' ? linkurl : undefined}
            className={`investor-tile js-loading fn_investor-tile fn_yourir ${backgroundcolor} ${transparent} ${
              linkurl ? 'hover' : 'hover-off'
            }`}
          >
            <YourIR appID={appID} hide={false}>
              <div className="investor-tile__content-container">
                <div className="investor-tile__title-container">
                  <div className="investor-tile__title">
                    <div
                      className="h1"
                      dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading) }}
                    ></div>
                  </div>
                </div>
                <div className="investor-tile__share-price-container">
                  <div className="investor-tile__share-label">{sharelabel}</div>
                  <div className="investor-tile__share-price">
                    <div className="price fn_price" data-yourir="price"></div>
                    <div className="movement">
                      <span data-yourir="changeSignCSS">
                        <span
                          className="icon icon--triangle-up up"
                          data-grunticon-embed="true"
                        ></span>
                        <span
                          className="icon icon--triangle-down down"
                          data-grunticon-embed="true"
                        ></span>
                      </span>
                    </div>
                  </div>
                  <div className="investor-tile__share-price-update-time">
                    {datetext}
                    <span data-yourir="currentTime format='DD MMM YYYY H:mm'"></span>
                  </div>
                </div>
                <div className="investor-tile__info-container">
                  <ul className="investor-tile__share-info">
                    {shareInfoItems.map((item) => (
                      <>
                        <li>
                          <div className="share-info-item">
                            <div className="label">{item.label}</div>
                            <div className="value">
                              <span data-yourir={item.yourIR}></span>
                            </div>
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
              </div>
            </YourIR>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FeaturedSharePrice;
